var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// export default {
//   'Today': {
//     startDate: (now) => {
//       return now;
//     },
//     endDate: (now) => {
//       return now;
//     }
//   },
//   'Last 7 Days': {
//     startDate: (now) => {
//       return now.subtract(6, 'days');
//     },
//     endDate: (now) => {
//       return now;
//     }
//   },
//   'Last 14 Days': {
//     startDate: (now) => {
//       return now.subtract(13, 'days');
//     },
//     endDate: (now) => {
//       return now;
//     }
//   },
//   'Last 28 Days': {
//     startDate: (now) => {
//       return now.subtract(27, 'days');
//     },
//     endDate: (now) => {
//       return now;
//     }
//   },
//   'Last 90 Days': {
//     startDate: (now) => {
//       return now.subtract(89, 'days');
//     },
//     endDate: (now) => {
//       return now;
//     }
//   },
//   'Last 120 Days': {
//     startDate: (now) => {
//       return now.subtract(119, 'days');
//     },
//     endDate: (now) => {
//       return now;
//     }
//   }
// }


import { addDays, endOfDay, startOfDay, startOfMonth, endOfMonth, addMonths, startOfWeek, endOfWeek, isSameDay, differenceInCalendarDays } from 'date-fns';

var defineds = {
  startOfWeek: startOfWeek(new Date()),
  endOfWeek: endOfWeek(new Date()),
  startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
  endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
  startOfToday: startOfDay(new Date()),
  endOfToday: endOfDay(new Date()),
  startOfYesterday: startOfDay(addDays(new Date(), -1)),
  endOfYesterday: endOfDay(addDays(new Date(), -1)),
  startOfMonth: startOfMonth(new Date()),
  endOfMonth: endOfMonth(new Date()),
  startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
  endOfLastMonth: endOfMonth(addMonths(new Date(), -1))
};

var staticRangeHandler = {
  range: {},
  isSelected: function isSelected(range) {
    var definedRange = this.range();
    return isSameDay(range.startDate, definedRange.startDate) && isSameDay(range.endDate, definedRange.endDate);
  }
};

export function createStaticRanges(ranges) {
  return ranges.map(function (range) {
    return _extends({}, staticRangeHandler, range);
  });
}

export var defaultStaticRanges = createStaticRanges([{
  label: 'Today',
  range: function range() {
    return {
      startDate: defineds.startOfToday,
      endDate: defineds.endOfToday
    };
  }
}, {
  label: 'Yesterday',
  range: function range() {
    return {
      startDate: defineds.startOfYesterday,
      endDate: defineds.endOfYesterday
    };
  }
}, {
  label: 'This Week',
  range: function range() {
    return {
      startDate: defineds.startOfWeek,
      endDate: defineds.endOfWeek
    };
  }
}, {
  label: 'Last Week',
  range: function range() {
    return {
      startDate: defineds.startOfLastWeek,
      endDate: defineds.endOfLastWeek
    };
  }
}, {
  label: 'This Month',
  range: function range() {
    return {
      startDate: defineds.startOfMonth,
      endDate: defineds.endOfMonth
    };
  }
}, {
  label: 'Last Month',
  range: function range() {
    return {
      startDate: defineds.startOfLastMonth,
      endDate: defineds.endOfLastMonth
    };
  }
}]);

export var defaultInputRanges = [{
  label: 'days up to today',
  range: function range(value) {
    return {
      startDate: addDays(defineds.startOfToday, (Math.max(Number(value), 1) - 1) * -1),
      endDate: defineds.endOfToday
    };
  },
  getCurrentValue: function getCurrentValue(range) {
    if (!isSameDay(range.endDate, defineds.endOfToday)) return '-';
    if (!range.startDate) return '∞';
    return differenceInCalendarDays(defineds.endOfToday, range.startDate) + 1;
  }
}, {
  label: 'days starting today',
  range: function range(value) {
    var today = new Date();
    return {
      startDate: today,
      endDate: addDays(today, Math.max(Number(value), 1) - 1)
    };
  },
  getCurrentValue: function getCurrentValue(range) {
    if (!isSameDay(range.startDate, defineds.startOfToday)) return '-';
    if (!range.endDate) return '∞';
    return differenceInCalendarDays(range.endDate, defineds.startOfToday) + 1;
  }
}];